import { ApiPath } from "enums";
import { Get } from "utils";

export const getStationById = async ({ stationId }) => {
  const res = await Get(`${ApiPath.Station}/${stationId}`);
  return res.data;
};
